export default __webpack_public_path__ + "static/media/IMG_4246.3cf7e136.jpeg";